import api from './api'
import { readGaIds, pushDataLayerEvent } from './ga4'

let isStartingCheckout = false
const STANDALONE_MONTHLY_PLAN_ID = process.env.STANDALONE_MONTHLY_PLAN_ID

const isValidPlanId = (value) => {
  if (!value) return false
  const normalized = String(value).trim().toLowerCase()
  return normalized !== 'undefined' && normalized !== 'null'
}

const resolveStandalonePlanIdFromBillingType = (billingType) => {
  if (billingType === 'per_seat' && isValidPlanId(STANDALONE_MONTHLY_PLAN_ID)) return STANDALONE_MONTHLY_PLAN_ID
  if (isValidPlanId(STANDALONE_MONTHLY_PLAN_ID)) return STANDALONE_MONTHLY_PLAN_ID
  return null
}

export const getProPlanId = (uiStore) => {
  const billingType = uiStore && uiStore.user && uiStore.user.plan && uiStore.user.plan.billing_type
  const mappedBillingPlanId = resolveStandalonePlanIdFromBillingType(billingType)
  if (isValidPlanId(mappedBillingPlanId)) return mappedBillingPlanId
  return null
}

export const startProCheckout = async ({ uiStore, t, planId } = {}) => {
  if (isStartingCheckout) return
  const resolvedPlanId = isValidPlanId(planId) ? planId : getProPlanId(uiStore)
  if (!isValidPlanId(resolvedPlanId)) {
    window.location.href = `${process.env.CORPORATE_URL}/pricing/`
  }

  isStartingCheckout = true

  try {
    const [response] = await Promise.all([
      api.purchasePlan(resolvedPlanId, {}, readGaIds()),
      pushDataLayerEvent('begin_checkout'),
    ])
    const sessionUrl = response && response.data && response.data.session_url
    if (!sessionUrl) {
      window.location.href = `${process.env.CORPORATE_URL}/pricing/`
    }
    window.location.href = sessionUrl
  } catch (error) {
    window.location.href = `${process.env.CORPORATE_URL}/pricing/`
  } finally {
    isStartingCheckout = false
  }
}
